import type { Validate } from 'react-hook-form';

import isEmpty from '@tinkoff/utils/is/empty';
import isNumber from '@tinkoff/utils/is/number';
import isObject from '@tinkoff/utils/is/object';
import isString from '@tinkoff/utils/is/string';
import trim from '@tinkoff/utils/string/trim';

import { plural } from '../../lib/plural';

interface MaxLenOptions {
  maxLength: number;
  text?: string;
}

export function maxLength(options: MaxLenOptions): Validate<unknown> {
  return function maxLengthValidator(value) {
    const isOptionsValid = isObject(options) && isNumber(options.maxLength);
    if (!isOptionsValid) {
      return undefined;
    }

    if (!isString(value) || isEmpty(value)) {
      return undefined;
    }

    if (trim(value).length > options.maxLength) {
      return (
        options.text ??
        `Limited to ${options.maxLength} ${plural(
          options.maxLength,
          'character',
          'characters'
        )}`
      );
    }
  };
}
